/**
 * AUTO-GENERATED by scripts/generate-go-icons.mjs — do not edit manually.
 * Re-run `pnpm --filter @design-system/icons generate:go-icons` to regenerate.
 */
import type { SVGProps } from "react";
import type React from "react";

import ConnectorCCS2 from "./components/connectors/connector-ccs2";
import ConnectorG105 from "./components/connectors/connector-g105";
import ConnectorMcs from "./components/connectors/connector-mcs";
import ConnectorType1 from "./components/connectors/connector-type1";
import ConnectorType2 from "./components/connectors/connector-type2";
import FacilityAirport from "./components/facilities/facility-airport";
import FacilityBicycle from "./components/facilities/facility-bicycle";
import FacilityBus from "./components/facilities/facility-bus";
import FacilityCafe from "./components/facilities/facility-cafe";
import FacilityCarPoolParking from "./components/facilities/facility-car-pool-parking";
import FacilityGasStation from "./components/facilities/facility-gas-station";
import FacilityHotel from "./components/facilities/facility-hotel";
import FacilityMall from "./components/facilities/facility-mall";
import FacilityMetro from "./components/facilities/facility-metro";
import FacilityMuseum from "./components/facilities/facility-museum";
import FacilityNature from "./components/facilities/facility-nature";
import FacilityParking from "./components/facilities/facility-parking";
import FacilityRecreationArea from "./components/facilities/facility-recreation-area";
import FacilityRestaurant from "./components/facilities/facility-restaurant";
import FacilitySport from "./components/facilities/facility-sport";
import FacilitySupermarket from "./components/facilities/facility-supermarket";
import FacilityTaxiCarPool from "./components/facilities/facility-taxi-car-pool";
import FacilityToilet from "./components/facilities/facility-toilet";
import FacilityTrain from "./components/facilities/facility-train";
import FacilityTram from "./components/facilities/facility-tram";
import FacilityWifi from "./components/facilities/facility-wifi";
import VehicleBus from "./components/vehicles/vehicle-bus";
import VehicleRigidTruck from "./components/vehicles/vehicle-rigid-truck";
import VehicleSemiTractor from "./components/vehicles/vehicle-semi-tractor";
import VehicleTruckTrailer from "./components/vehicles/vehicle-truck-trailer";

export type CustomIconName =
  | "connectorCCS2"
  | "connectorG105"
  | "connectorMcs"
  | "connectorType1"
  | "connectorType2"
  | "facilityAirport"
  | "facilityBicycle"
  | "facilityBus"
  | "facilityCafe"
  | "facilityCarPoolParking"
  | "facilityGasStation"
  | "facilityHotel"
  | "facilityMall"
  | "facilityMetro"
  | "facilityMuseum"
  | "facilityNature"
  | "facilityParking"
  | "facilityRecreationArea"
  | "facilityRestaurant"
  | "facilitySport"
  | "facilitySupermarket"
  | "facilityTaxiCarPool"
  | "facilityToilet"
  | "facilityTrain"
  | "facilityTram"
  | "facilityWifi"
  | "vehicleBus"
  | "vehicleRigidTruck"
  | "vehicleSemiTractor"
  | "vehicleTruckTrailer";

export const customIconMap: Record<
  CustomIconName,
  React.MemoExoticComponent<
    (props: SVGProps<SVGSVGElement>) => React.JSX.Element
  >
> = {
  connectorCCS2: ConnectorCCS2,
  connectorG105: ConnectorG105,
  connectorMcs: ConnectorMcs,
  connectorType1: ConnectorType1,
  connectorType2: ConnectorType2,
  facilityAirport: FacilityAirport,
  facilityBicycle: FacilityBicycle,
  facilityBus: FacilityBus,
  facilityCafe: FacilityCafe,
  facilityCarPoolParking: FacilityCarPoolParking,
  facilityGasStation: FacilityGasStation,
  facilityHotel: FacilityHotel,
  facilityMall: FacilityMall,
  facilityMetro: FacilityMetro,
  facilityMuseum: FacilityMuseum,
  facilityNature: FacilityNature,
  facilityParking: FacilityParking,
  facilityRecreationArea: FacilityRecreationArea,
  facilityRestaurant: FacilityRestaurant,
  facilitySport: FacilitySport,
  facilitySupermarket: FacilitySupermarket,
  facilityTaxiCarPool: FacilityTaxiCarPool,
  facilityToilet: FacilityToilet,
  facilityTrain: FacilityTrain,
  facilityTram: FacilityTram,
  facilityWifi: FacilityWifi,
  vehicleBus: VehicleBus,
  vehicleRigidTruck: VehicleRigidTruck,
  vehicleSemiTractor: VehicleSemiTractor,
  vehicleTruckTrailer: VehicleTruckTrailer,
};
